import { render, staticRenderFns } from "./StockInsights.vue?vue&type=template&id=4d7b18c3&scoped=true&"
import script from "./StockInsights.vue?vue&type=script&lang=js&"
export * from "./StockInsights.vue?vue&type=script&lang=js&"
import style0 from "./StockInsights.vue?vue&type=style&index=0&id=4d7b18c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b18c3",
  null
  
)

export default component.exports